export default __webpack_public_path__ + "static/media/genderNeutralRestroomDark.a2201a0b.svg";